/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const mobile_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M7.875.75V0v.75Zm0 22.5V24v-.75Zm8.25 0V24v-.75Zm3-3h.75-.75Zm0-16.5h.75-.75Zm-3-3.75h-8.25v1.5h8.25V0Zm-8.25 0a3.75 3.75 0 0 0-2.652 1.098L6.284 2.16a2.25 2.25 0 0 1 1.591-.66V0ZM5.223 1.098A3.75 3.75 0 0 0 4.125 3.75h1.5c0-.597.237-1.169.659-1.591l-1.06-1.06ZM4.125 3.75v16.5h1.5V3.75h-1.5Zm0 16.5a3.75 3.75 0 0 0 1.098 2.652l1.061-1.061a2.25 2.25 0 0 1-.659-1.591h-1.5Zm1.098 2.652A3.75 3.75 0 0 0 7.875 24v-1.5a2.25 2.25 0 0 1-1.591-.659l-1.06 1.06ZM7.875 24h8.25v-1.5h-8.25V24Zm8.25 0a3.75 3.75 0 0 0 2.652-1.098l-1.061-1.061a2.25 2.25 0 0 1-1.591.659V24Zm2.652-1.098a3.75 3.75 0 0 0 1.098-2.652h-1.5a2.25 2.25 0 0 1-.659 1.591l1.06 1.06Zm1.098-2.652V3.75h-1.5v16.5h1.5Zm0-16.5a3.75 3.75 0 0 0-1.098-2.652L17.716 2.16c.422.422.659.994.659 1.591h1.5Zm-1.098-2.652A3.75 3.75 0 0 0 16.125 0v1.5a2.25 2.25 0 0 1 1.591.659l1.06-1.06ZM12 4.25v1.5a1.5 1.5 0 0 0 1.5-1.5H12Zm0 0h-1.5a1.5 1.5 0 0 0 1.5 1.5v-1.5Zm0 0v-1.5a1.5 1.5 0 0 0-1.5 1.5H12Zm0 0h1.5a1.5 1.5 0 0 0-1.5-1.5v1.5Z"
    />
  </svg>
)
export default mobile_medium
